import { createSelector } from "reselect";
import store from "../../../store";
import { RootState } from "../../rootReducer";

export const selectLocationsSelected = createSelector(
  [
    (store: RootState) => store.userProfileLocation.selectedLocations,
    (store: RootState) => store.userProfileLocation.selectedSearchText,
  ],
  (selectedLocations, selectedSearchText) => {
    const data = selectedLocations.filter(
      ({ name, code }) => {
        // Filtro por nombre y código 
        if (
          selectedSearchText
          && !name?.toLowerCase().includes(selectedSearchText?.toLowerCase().trim())
          && !code?.toLowerCase().includes(selectedSearchText?.toLowerCase().trim())
        ) {
          return false;
        }
        return true;
      }
    );
    const orderedList = [...data].sort((a, b) => {
      if (a.name && b.name && a.name < b.name) {
        return -1;
      }
      if (a.name && b.name && a.name > b.name) {
        return 1;
      }
      return 0;
    });

    return orderedList;
  }
);

// Devuelve el listado de locations seleccionados o asignados ordenados por nombre
// (data) => [...data].sort((a, b) => {
//   if (a.name && b.name && a.name < b.name) {
//     return -1;
//   }
//   if (a.name && b.name && a.name > b.name) {
//     return 1;
//   }
//   return 0;
// })
// );
